import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  backdrop: { zIndex: theme.zIndex.modal + 11 },
}));

export default useStyles;
